module.exports = __webpack_public_path__ + "img/cash.f1828bc4.png";